@if (breadCrumbConfig.length > 0) {
  <div class="flex flex-row w-full h-full items-center" [ngClass]="{'breadcrumb' : showBreadcrumb}">
    @for (breadCrumb of breadCrumbConfig; track breadCrumb; let first = $first; let last = $last) {
      @if (!first) {
        <mat-icon>chevron_right</mat-icon>
      }
        <span id="global-breadcrumb-label" [ngClass]="{
'mr-2': first,
'mx-1': !first,
'color-tree-poppy': last,
'text-[var(--pale-sky)] dark:text-[var(--athens-gray)]': !last
        }">{{breadCrumb.name | translate}}</span>
    }
  </div>
}